import React, { useContext } from "react";
import classnames from "classnames";
import { diffChars } from "diff";
import LogContext from "./LogContext";
import {
  teaserStatusName,
  gradeStatusName,
  payoutName,
  showTypeName
} from "../../constants";

function defaultRender(action, isNew) {
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {isNew ? action.new_value : action.old_value}
    </span>
  );
}

function diffRender(action, isNew) {
  if (!isNew) {
    return action.old_value;
  }

  const diff = diffChars(action.old_value, action.new_value);

  return diff.map(part => {
    const className = part.added
      ? "diff-green"
      : part.removed
      ? "diff-red"
      : "";
    return <span className={className}>{part.value}</span>;
  });
}

function cidRender(action, isNew) {
  const logContext = useContext(LogContext);

  const cid = isNew ? action.new_value : action.old_value;
  const campaign = logContext.campaigns[cid] || {};

  if (!cid) {
    return "Нет";
  }

  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {campaign.name} [{campaign.id}]
    </span>
  );
}

function categoryRender(action, isNew) {
  const logContext = useContext(LogContext);

  const cat_id = isNew ? action.new_value : action.old_value;
  const cat = logContext.categories[cat_id] || {};

  if (!cat_id) {
    return "Нет";
  }

  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {cat.name} [{cat.id}]
    </span>
  );
}

function published2name(published) {
  return teaserStatusName[published] || published;
}

function publishedRender(action, isNew) {
  const published = isNew ? action.new_value : action.old_value;
  const statusName = published2name(published);
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {statusName}
    </span>
  );
}

function payout2name(status) {
  return payoutName[status] || status;
}

function payoutRender(action, isNew) {
  const status = isNew ? action.new_value : action.old_value;
  const statusName = payout2name(status);
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {statusName}
    </span>
  );
}

function grade2name(status) {
  return gradeStatusName[status] || status;
}

function gradeRender(action, isNew) {
  const status = isNew ? action.new_value : action.old_value;
  const statusName = grade2name(status);
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {statusName}
    </span>
  );
}

function ttlRender(action, isNew) {
  const ttl = isNew ? action.new_value : action.old_value;
  const value = ttl ? ttl : "Нет";
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {value}
    </span>
  );
}

function resetRender(action, isNew) {
  const reset = isNew ? action.new_value : action.old_value;
  const value = reset == "True" ? "Поставлен на перезакидывание" : "Нет";
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {value}
    </span>
  );
}

function type2name(type) {
  return showTypeName[type] || type;
}

function typeRender(action, isNew) {
  const type = isNew ? action.new_value : action.old_value;
  const typeName = type2name(type);
  return (
    <span className={classnames({ "diff-new": isNew, "diff-old": !isNew })}>
      {typeName}
    </span>
  );
}

const renderMap = {
  title: diffRender,
  desc: diffRender,
  url: diffRender,
  cid: cidRender,
  category: categoryRender,
  published: publishedRender,
  payout_status: payoutRender,
  grade_status: gradeRender,
  active_until: ttlRender,
  should_reset_stat: resetRender,
  type: typeRender
};

const FieldValue = ({ action, isNew }) => {
  const render = renderMap[action.field_name] || defaultRender;

  return render(action, isNew);
};

export default FieldValue;
